import {Component, OnInit, Input} from '@angular/core';
import {AjaxService} from 'AjaxService';

@Component({
    selector: 'aBe-i-uebersicht',
    templateUrl: './aBe-i-uebersicht.component.html',
    styleUrls: ['./aBe-i-uebersicht.component.css'],
    standalone: false
})
export class AntragBeInternUebersichtComponent implements OnInit {
  @Input() antragBeId: number;

  data: any;
  loading: number = 1;

  p: any = {};

  constructor(private ajaxService: AjaxService) {}

  load() {
    this.startLoading(1);
    this.ajaxService.post<any>('api/InternAntragBe/GetUebersicht', {antragBeId: this.antragBeId}).subscribe({
      next: (response) => {
        this.data = response;
        this.stopLoading();
      },
      error: (e) => {
        this.stopLoading();
        throw e;
      },
    });
  }

  ngOnInit(): void {
    this.load();
  }

  getEinrichtungsteilCaption(ue, i) {
    return i + 1 + '. Einrichtung (' + ue.name + ')';
  }

  getPersonalCaption(p, u) {
    return u + 1 + '. ' + p.name;
  }

  calculateCellValue_Bis(event: any) {
    if (event) {
      if (event.bisJetzt) {
        return 'bis jetzt';
      }

      if (event.bis) {
        return new Date(event.bis).toLocaleDateString('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'});
      }
    }

    return '';
  }

  download(name, bez) {
    const re = /\./gi;
    const fileName = new Date().toLocaleDateString('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}).replace(re, '-') + '_' + bez + this.getFileExtension1(name);
    this.ajaxService.download('/api/Dokument/Download?fileName=' + name + '&dokumentName=' + bez, fileName);
  }

  getFileExtension1(filename) {
    return /[.]/.exec(filename) ? '.' + /[^.]+$/.exec(filename)[0] : undefined;
  }

  startLoading(state: number) {
    this.loading = state;
  }

  stopLoading() {
    this.loading = 0;
  }
}
